import { render, staticRenderFns } from "./NewAMForgotUserIDInfo.vue?vue&type=template&id=4b864457&scoped=true"
import script from "./NewAMForgotUserIDInfo.vue?vue&type=script&lang=js"
export * from "./NewAMForgotUserIDInfo.vue?vue&type=script&lang=js"
import style0 from "./NewAMForgotUserIDInfo.vue?vue&type=style&index=0&id=4b864457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b864457",
  null
  
)

export default component.exports